var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "#DEEBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47471_15621)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4.90267C10.3583 4.49647 10.8318 4.20901 11.3575 4.07853C11.8832 3.94805 12.4361 3.98075 12.9428 4.17227C13.4494 4.36379 13.8857 4.70505 14.1937 5.15064C14.5016 5.59623 14.6665 6.12503 14.6665 6.66667C14.6665 7.20831 14.5016 7.7371 14.1937 8.18269C13.8857 8.62829 13.4494 8.96955 12.9428 9.16107C12.4361 9.35259 11.8832 9.38528 11.3575 9.2548C10.8318 9.12433 10.3583 8.83687 10 8.43067M12 16H4V15.3333C4 14.2725 4.42143 13.2551 5.17157 12.5049C5.92172 11.7548 6.93913 11.3333 8 11.3333C9.06087 11.3333 10.0783 11.7548 10.8284 12.5049C11.5786 13.2551 12 14.2725 12 15.3333V16ZM12 16H16V15.3333C16.0001 14.6311 15.8153 13.9413 15.4643 13.3331C15.1133 12.725 14.6083 12.2199 14.0002 11.8688C13.3922 11.5177 12.7023 11.3328 12.0001 11.3328C11.2979 11.3327 10.6081 11.5176 10 11.8687M10.6667 6.66667C10.6667 7.37391 10.3857 8.05219 9.88562 8.55229C9.38552 9.05238 8.70724 9.33333 8 9.33333C7.29276 9.33333 6.61448 9.05238 6.11438 8.55229C5.61428 8.05219 5.33333 7.37391 5.33333 6.66667C5.33333 5.95942 5.61428 5.28115 6.11438 4.78105C6.61448 4.28095 7.29276 4 8 4C8.70724 4 9.38552 4.28095 9.88562 4.78105C10.3857 5.28115 10.6667 5.95942 10.6667 6.66667Z",
    stroke: "#0065FF",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47471_15621"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGroup);
export default __webpack_public_path__ + "static/media/home-group.1a8af9eb7dd88fe8c2b5c3e5061a20ae.svg";
export { ForwardRef as ReactComponent };